export type MacOSReleaseTarget = 'stable' | 'beta' | 'tutorial'

export interface MacOSVersion {
  version: string
  versionCode: number
  minVersionCode: number
  sha256: string
  size: number
  edSignature: string
  minimumSystemVersion: string
  downloadUrl: string
  releaseNotes: string
  releaseNotesEn: string
  createdAt: string
  extra: { r2_key: string, original_filename: string }
}

export interface MacOSUpdateState {
  channels: Record<'stable' | 'beta', MacOSVersion | null>
  downloads: { tutorial: MacOSVersion | null }
  versions: MacOSVersion[]
}

export interface MacOSReleaseMetadata {
  versionName: string
  versionCode: number
  sha256: string
  size: number
  edSignature: string
  minimumSystemVersion: string
}

export function parseMacOSReleaseMetadata(value: unknown): MacOSReleaseMetadata {
  if (!value || typeof value !== 'object') throw new Error('无效的发布元数据')
  const data = value as MacOSReleaseMetadata
  if (!/^\d+(?:\.\d+){1,2}(?:-(?:beta|rc)\.\d+)?$/.test(data.versionName)
    || data.versionName.length > 15
    || !Number.isSafeInteger(data.versionCode) || data.versionCode <= 0
    || !Number.isSafeInteger(data.size) || data.size <= 0
    || !/^[a-f0-9]{64}$/.test(data.sha256)
    || !/^[A-Za-z0-9+/]{86}==$/.test(data.edSignature)
    || !/^\d{2}(?:\.\d{1,2}){1,2}$/.test(data.minimumSystemVersion)) {
    throw new Error('元数据缺少有效的版本、build、文件大小、SHA-256、Ed25519 签名或最低系统版本')
  }
  return data
}

export function verifyMacOSReleaseFile(metadata: MacOSReleaseMetadata, file: { name: string, size: number }, sha256: string) {
  if (!file.name.toLowerCase().endsWith('.dmg')) throw new Error('请选择 .dmg 安装包')
  if (metadata.size !== file.size || metadata.sha256 !== sha256) throw new Error('DMG 与发布元数据不匹配，请选择签名时使用的原始安装包')
}
